import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Logo } from "@shared/components/Logo";
import { CenterSwitcher } from "@shared/components/CenterSwitcher";
import { GlobalSearch } from "../GlobalSearch";
import { useGlobalSearch } from "../../lib/useGlobalSearch";

export function AdminMobileHeader() {
  const { isOpen, open, close, query, setQuery, results, gatedCount, loading } = useGlobalSearch();

  // Cmd+K / Ctrl+K shortcut
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        open();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open]);

  return (
    <>
      <header className="sticky top-0 z-40 flex h-12 items-center justify-between border-b border-border/40 bg-bg/95 px-4 backdrop-blur-sm safe-top">
        <Link to="/" className="shrink-0">
          <Logo size="sm" showDots={false} />
        </Link>

        <div className="min-w-0 flex-1 flex justify-center px-3">
          <CenterSwitcher />
        </div>

        <button
          data-tour="mobile-search"
          onClick={open}
          className="shrink-0 p-1.5 text-muted active:text-foreground transition-colors"
          aria-label="Search"
        >
          <Search className="w-[22px] h-[22px]" />
        </button>
      </header>

      <GlobalSearch
        isOpen={isOpen}
        query={query}
        setQuery={setQuery}
        results={results}
        gatedCount={gatedCount}
        loading={loading}
        close={close}
      />
    </>
  );
}
